/*import Vue from 'vue'
import VueRouter from 'vue-router'
import App from './App.vue'
import RouterComp from './components/RouterComp.vue'

Vue.use(VueRouter)

const router = new VueRouter({
  routes: [
    { path: '/RouterComp/:userId', component: RouterComp }
  ]
})

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')



import axios from 'axios';
*/
import { createApp } from 'vue'
import App from './App.vue'
import { router } from './router'
import { createAuth0 } from '@auth0/auth0-vue';
import '@fortawesome/fontawesome-free/css/all.css'




const app = createApp(App).use(router)

app.use(router);
app.use(
  createAuth0({
    domain: "dev-zs8ixh1oi36qhrbl.us.auth0.com",
    clientId: "AVhmd6Lwk9uzflGgwQmjfTQ14JcQz0Q1",
    authorizationParams: {
      redirect_uri: window.location.origin
    }
  })
  
);

app.mount('#app')

